import { Pipe, PipeTransform } from '@angular/core';
import { NGXSelectMayRow } from './ngx-selectbox-may-configs';
@Pipe({
    name: 'ngx_item_filter',
    pure: false
})
export class NGXSelectboxMayPipe implements PipeTransform {
    transform(items: NGXSelectMayRow[], filter: string): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.label.toUpperCase().indexOf(filter.toUpperCase()) !== -1);
    }
}
